import tinycolor from "tinycolor2";

import { uiGray, white } from "constants/colors";

// This is only abstracted to normalize the default darkening factor
export const darkenColor = (hexColor: string, factor = 10) => {
  const color = tinycolor(hexColor);
  return color.darken(factor).toHexString();
};

// This is only abstracted to normalize the default lightening factor
export const lightenColor = (hexColor: string, factor = 38) => {
  const color = tinycolor(hexColor);
  return color.lighten(factor).toHexString();
};

// This is abstracted here as it can be used in multiple places
// if the color is not visible against white it falls back on our fallback color
export const getColorVisibleAgainstWhite = (
  hexColor: string,
  fallback = uiGray[90]
) => {
  return tinycolor.isReadable(hexColor, white, {}) ? hexColor : fallback; // false
};
